__turbopack_context__.v({
  "className": "itw_Wq_className",
  "variable": "itw_Wq_variable",
});
